module.exports = ".addModalDialog {\n  width: 800px; }\n\n.mat-form-field {\n  width: 150px; }\n\n.txtAreaRecm {\n  width: 450px; }\n"